import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import IssueCard from './IssueCard';
import { Plus } from 'lucide-react';

const LANE_CONFIG = {
  backlog:     { label: 'Backlog',     color: 'bg-gray-100',   dot: 'bg-gray-400',   text: 'text-gray-600' },
  up_next:     { label: 'Up Next',     color: 'bg-blue-50',    dot: 'bg-blue-400',   text: 'text-blue-700' },
  in_progress: { label: 'In Progress', color: 'bg-yellow-50',  dot: 'bg-yellow-400', text: 'text-yellow-700' },
  done:        { label: 'Done',        color: 'bg-green-50',   dot: 'bg-green-400',  text: 'text-green-700' },
  rejected:    { label: 'Rejected',    color: 'bg-red-50',     dot: 'bg-red-400',    text: 'text-red-700' },
};

const KanbanLane = ({ laneId, issues, onCardClick, onAddClick }) => {
  const config = LANE_CONFIG[laneId] || { label: laneId, color: 'bg-gray-100', dot: 'bg-gray-400', text: 'text-gray-600' };

  const { setNodeRef, isOver } = useDroppable({ id: laneId });

  return (
    <div className="flex flex-col w-72 flex-shrink-0">
      {/* Lane header */}
      <div className={`flex items-center justify-between px-3 py-2.5 rounded-xl mb-2 ${config.color}`}>
        <div className="flex items-center gap-2">
          <span className={`inline-block w-2.5 h-2.5 rounded-full ${config.dot}`} />
          <span className={`text-sm font-semibold ${config.text}`}>{config.label}</span>
          <span className={`text-xs font-medium px-1.5 py-0.5 rounded-full bg-white/60 ${config.text}`}>
            {issues.length}
          </span>
        </div>
        {laneId === 'backlog' && (
          <button
            onClick={onAddClick}
            className={`p-0.5 rounded-lg hover:bg-white/60 transition-colors ${config.text}`}
            title="New issue"
          >
            <Plus className="h-4 w-4" />
          </button>
        )}
      </div>

      {/* Cards */}
      <div
        ref={setNodeRef}
        className={`flex-1 min-h-[100px] space-y-2.5 rounded-xl p-1.5 transition-colors ${
          isOver ? 'bg-yellow-50/60 ring-2 ring-yellow-300 ring-dashed' : ''
        }`}
      >
        <SortableContext items={issues.map(i => i.id)} strategy={verticalListSortingStrategy}>
          {issues.map(issue => (
            <IssueCard
              key={issue.id}
              issue={issue}
              onClick={() => onCardClick(issue)}
            />
          ))}
        </SortableContext>
        {issues.length === 0 && (
          <div className="flex items-center justify-center h-16 text-xs text-gray-400 italic">
            Drop here
          </div>
        )}
      </div>
    </div>
  );
};

export default KanbanLane;
